import { msiRequest } from "../../index";
import { ResultType } from "../../types";
import qs from "qs";
enum downEnumApi {
    FILEDOWNLOAD = '/sysFileInfo/download',//文件下载
    RECEIVINGRECORD = '/sysFileInfo/preview',//预览文件
}
export function downLoadFunction(data: any) {
    return msiRequest.get({
        url: `${downEnumApi.FILEDOWNLOAD}?${qs.stringify(data)}`,
        responseType: 'blob',
        data
    })
}
export function downLoadRecordFunction(data: any) {
    return msiRequest.get({
        url: `${downEnumApi.RECEIVINGRECORD}?${qs.stringify(data)}`,
        // responseType: 'blob',
        data
    })
}